/*eslint-disable*/
import { Helmet } from 'react-helmet-async';
import React, { useState, useEffect } from 'react';

// @mui
import {
  Button,
  Container,
  Stack,
  Typography,
  CardContent,
  FormControlLabel,
  Card,
  CardActions,
  Chip,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Dialog,
  Slide,
  DialogActions,
} from '@mui/material';
import { getToken } from 'src/utils/common';
import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import FavoriteIcon from '@mui/icons-material/Favorite';
import Avatar, { genConfig } from 'react-nice-avatar';
import TextField from '@mui/material/TextField';
import CircleIcon from '@mui/icons-material/Circle';
import { BlogPostsSort, BlogPostsSearch } from '../sections/@dashboard/blog';
// mock
import POSTS from '../_mock/blog';
// components
import Iconify from '../components/iconify';

// ----------------------------------------------------------------------

const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];

const capitalizeFirst = (str) => {
  var str1 = str.split('_').join(' ');
  return str1.charAt(0).toUpperCase() + str1.slice(1);
};
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// ----------------------------------------------------------------------

export default function BlogPage(props) {
  const { listnamapegawai } = props;
  const [isSubmitting, setisSubmitting] = React.useState(false);
  const [rule, setRule] = React.useState([]);
  const [action, setAction] = React.useState([]);
  const [status, setStatus] = React.useState('');
  const [rulesname, setRulesname] = React.useState('');
  const [data, setdata] = React.useState([]);
  const [description, setdescription] = React.useState('');
  const [message1, setMessage1] = React.useState('');
  const [tittle, settittle] = React.useState('');
  const config = genConfig();
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  let handleSubmit1 = async (e) => {
    e.preventDefault();
    try {
      let res = await fetch(window.REACT_APP_API_PURE + 'bulletin/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify({
          tittle: tittle,
          description: description,
        }),
      });
      let resJson = await res.json();
      if (res.status === 200) {
        settittle('');
        setdescription('');
        setMessage1('Procedures created successfully');
        fetchInfo1(window.REACT_APP_API_PURE + 'bulletin/list');
        setOpen(false);
      } else {
        setMessage1('Some error occured');
        setOpen(false);
      }
      await new Promise((resolve) => setTimeout(resolve, 1000));
      actions.resetForm();
    } catch (err) {
      console.log(err);
    }
  };

  const [data1, setData1] = useState([]);

  const fetchInfo1 = (url1) => {
    return fetch(url1, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => setData1(d));
  };
  console.log(data1);
  useEffect(() => {
    fetchInfo1(window.REACT_APP_API_PURE + 'bulletin/list');
  }, []);

  return (
    <>
      <Helmet>
        <title> Bulletin | Smartshield </title>
      </Helmet>

      <Container>
        <span>
          <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            fullWidth={true}
            maxWidth={'md'}
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle>{'Generate Bulletin'}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                <Grid container direction={'row'}>
                  <Grid item container direction={'column'} xs={12}>
                    {' '}
                    <Grid item>
                      <Typography variant="caption"> Title</Typography>
                    </Grid>
                    <Grid item>
                      {' '}
                      <TextField
                        fullWidth
                        multiline
                        value={tittle}
                        onChange={(e) => {
                          settittle(e.target.value);
                        }}
                      ></TextField>
                    </Grid>
                  </Grid>
                  <Grid item container direction={'column'}>
                    {' '}
                    <Grid item>
                      <Typography variant="caption"> Description</Typography>
                    </Grid>
                    <Grid item>
                      {' '}
                      <TextField
                        fullWidth
                        multiline
                        value={description}
                        onChange={(e) => {
                          setdescription(e.target.value);
                        }}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button type="submit" onClick={handleSubmit1} autoFocus>
                Submit
              </Button>
            </DialogActions>
          </Dialog>
          <Grid container direction={'column'} style={{ padding: 40 }}>
            <Grid item alignSelf={'flex-end'}>
              {' '}
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                style={{
                  textTransform: 'none',
                  backgroundColor: '#679DA0',
                }}
                onClick={handleClickOpen}
              >
                Generate Bulletin
              </Button>
            </Grid>
            <Grid item container direction={'row'} spacing={2}>
              <Grid item>
                <CircleIcon style={{ color: '#fb6992' }} fontSize="small" />
              </Grid>
              <Grid item>Today</Grid>
            </Grid>
            {data1?.data?.map((dataObj, index) => {
              return (
                <Grid item>
                  <Card>
                    <CardContent>
                      <Grid container direction={'row'} spacing={3}>
                        <Grid item container direction={'column'} xs={1} alignItems="center">
                          <Grid item>
                            {' '}
                            <Avatar style={{ width: '4rem', height: '4rem' }} {...config} />
                          </Grid>{' '}
                          <Grid item>
                            {' '}
                            <Typography variant="caption">{dataObj.created_by}</Typography>
                          </Grid>{' '}
                        </Grid>
                        <Grid item container direction={'column'} xs>
                          <Grid item>
                            {' '}
                            <Typography variant="h5" fontWeight={'bolder'}>
                              {dataObj.tittle}
                            </Typography>
                          </Grid>
                          <Grid item>
                            <Typography
                              variant="subtitle1"
                              sx={{
                                display: '-webkit-box',
                                overflow: 'hidden',
                                WebkitBoxOrient: 'vertical',
                                WebkitLineClamp: 2,
                              }}
                            >
                              {dataObj.description}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions style={{ backgroundColor: '#f1f3f9' }}>
                      <Grid container direction={'row'}>
                        <Grid item>
                          <Chip style={{ backgroundColor: '#dfe3ef' }} icon={<FavoriteIcon />} label="5" />
                        </Grid>
                      </Grid>
                    </CardActions>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        </span>
      </Container>
    </>
  );
}
